import * as React from 'react';
export function useForceUpdate() {
    const [, dispatch] = React.useState(Object.create(null));
    return React.useCallback(() => {
        dispatch(Object.create(null));
    }, []);
}
//# sourceMappingURL=useForceUpdate.js.map